<template>
  <div class="container-full">
    <div class="banner">
      <img :src="volunteerData.banner1920" class="b1" />
      <img :src="volunteerData.banner1200" class="b2" />
      <img :src="volunteerData.banner750" class="b3" />
      <img class="b4" src="../../assets/img/arrow-up-circle.png" />
    </div>

    <Modal v-model="modal2" width="450">
      <div style="text-align: center">
        <p>
          <Icon
            style="font-size: 18px; color: #ed4014; margin-right: 10px"
            type="ios-information-circle"
          ></Icon
          >{{ volunteerData.success }}
        </p>
      </div>
      <div slot="footer">
        <Button
          type="info"
          size="large"
          long:loading="modal_loading"
          @click="modal2 = false"
          >返回</Button
        >
      </div>
    </Modal>

    <div class="video-list container">
      <div class="p1">
        <div class="pbox">
          <div class="msg">
            <h3 class="text-center">{{ volunteerData.title }}</h3>
            <p>{{ volunteerData.about }}</p>
          </div>
        </div>
        <!-- <div class="map" id="baidumap">
          <!-- <img src="../../assets/img/volunteer/map.png" class="m1" />
          <img src="../../assets/img/volunteer/map2.png" class="m2" />
        </div> -->
      </div>

      <div class="p2">
        <div class="p2top">
          <ul class="a">
            <li class="one">活动说明：</li>
            <li>{{ volunteerData.s1 }}</li>
          </ul>
          <ul class="a">
            <li class="one">报名条件：</li>
            <li>{{ volunteerData.s2 }}</li>
          </ul>
          <ul class="a">
            <li class="one">支教学校：</li>
            <li>{{ volunteerData.s3 }}</li>
          </ul>
          <ul class="a">
            <li class="two">* 为必填项&nbsp;&nbsp;&nbsp;&nbsp;</li>
            <li>&nbsp;</li>
          </ul>
          <div class="formbox" v-if="!volunteerData.isStart">
            <div class="formtitle">
              {{ volunteerData.tip }}
            </div>
          </div>
          <div class="formbox">
            <div class="formtitle">
              {{ volunteerData.schoollabel }}
            </div>
            <!-- <RadioGroup v-model="postData.single" size="large">
              <Row>
                <Col
                  :xs="24"
                  :sm="24"
                  :md="12"
                  :lg="12"
                  v-for="(v, key) in volunteerData.schooladdress"
                  :key="key"
                >
               
                  <Radio class="fontbig" :label="v.title"></Radio
                ></Col>
              </Row>
            </RadioGroup> -->

            <!-- {{postData.single}} -->

            <CheckboxGroup v-model="postData.single">
              <Row>
                <Col
                  :xs="24"
                  :sm="24"
                  :md="12"
                  :lg="12"
                  v-for="(v, key) in volunteerData.schooladdress"
                  :key="key"
                  ><Checkbox
                    :label="v.title"
                    :value="v.title"
                    class="mt10"
                  ></Checkbox>
                </Col>
              </Row>
            </CheckboxGroup>
            <!-- <checkbox-group v-model="postData.single" >
                
                    <checkbox :xs="24"
                  :sm="24"
                  :md="12"
                  :lg="12"
                      v-for="(v, key) in volunteerData.schooladdress"
                  :key="key" :label="v.title" :value="v.title">
                        </checkbox>
                     
                </checkbox-group> -->
          </div>

          <div class="formbox">
            <div class="formtitle">您的个人资料 *</div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <Input
                  class="fontbig"
                  v-model="postData.name"
                  placeholder="姓名"
                />
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">
              您是否为东风日产（日产、启辰、英菲尼迪）的车主 *
            </div>
            <RadioGroup v-model="postData.car" size="large">
              <Row>
                <Col :xs="20" :sm="16" :md="12" :lg="12">
                  <Radio class="fontbig" label="是"></Radio
                ></Col>
                <Col :xs="20" :sm="16" :md="12" :lg="12">
                  <Radio class="fontbig" label="否"></Radio
                ></Col>
              </Row>
            </RadioGroup>
          </div>

          <div class="formbox">
            <div class="formtitle">
              出生年份
            </div>
            <RadioGroup v-model="postData.car" size="large">
              <Row>
                <Col :xs="20" :sm="16" :md="24" :lg="24">
                  <Input
                  class="fontbig"
                  v-model="postData.year"
                  placeholder="出生年份"
                >
                  <span slot="append">年</span>
                </Input>
                </Col>
               
              </Row>
            </RadioGroup>
          </div>

          <div class="formbox">
            <!-- <div class="formtitle">您的个人资料 *</div> -->
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <div class="formtitle">最高学历</div>
                <RadioGroup class="" v-model="postData.edu" size="large">
                  <Row>
                    <Col :xs="8" :sm="8" :md="12" :lg="12">
                      <Radio class="" label="高中"></Radio
                    ></Col>
                    <Col :xs="8" :sm="8" :md="12" :lg="12">
                      <Radio class="" label="本科"></Radio
                    ></Col>
                    <Col :xs="8" :sm="8" :md="12" :lg="12">
                      <Radio class="" label="硕士"></Radio
                    ></Col>
                    <Col :xs="8" :sm="8" :md="12" :lg="12">
                      <Radio class="" label="博士及以上"></Radio
                    ></Col>
                    <Col :xs="8" :sm="8" :md="12" :lg="12">
                      <Radio class="" label="其他"></Radio
                    ></Col>
                  </Row>
                </RadioGroup>
              </Col>
            </Row>
              </div>
              <div class="formbox">
              <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <div class="formtitle">性别</div>
                <RadioGroup v-model="postData.sex" size="large">
                  <Row>
                    <Col :xs="12" :sm="12" :md="12" :lg="12">
                      <Radio label="男"></Radio
                    ></Col>
                    <Col :xs="12" :sm="12" :md="12" :lg="12">
                      <Radio label="女"></Radio
                    ></Col>
                  </Row>
                </RadioGroup>
              </Col>
            </Row>
                <Row class="formbox">
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">

                <Input
                  v-model="postData.unit"
                  placeholder="所在单位/学校与岗位"
                />
                <Input
                  class="fontbig"
                  v-model="postData.school"
                  placeholder="毕业院校"
                />
                <Input
                  class="fontbig"
                  v-model="postData.mobile"
                  placeholder="联系手机"
                />
                <Input
                  class="fontbig"
                  v-model="postData.email"
                  placeholder="常用邮箱"
                />
              </Col>
            </Row>
          </div>

          <div class="formbox">
            <div class="formtitle">您的所在地*</div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 8 }" :lg="{ span: 8 }">
                <Input
                  class="fontbig"
                  v-model="postData.province"
                  placeholder="省"
                >
                  <span slot="append">省</span>
                </Input>
              </Col>
              <Col
                :xs="24"
                :sm="24"
                :md="{ span: 8, offset: 4 }"
                :lg="{ span: 8, offset: 4 }"
              >
                <Input
                  class="fontbig"
                  v-model="postData.city"
                  placeholder="市/区/县"
                >
                  <span slot="append">市/区/县</span>
                </Input>
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">您的教学内容适应年级*</div>
            <RadioGroup v-model="postData.agegroup" size="large">
              <Row>
                <Col :xs="20" :sm="16" :md="8" :lg="8">
                  <Radio class="fontbig" label="1～3年级"></Radio
                ></Col>
                <Col :xs="20" :sm="16" :md="8" :lg="8">
                  <Radio class="fontbig" label="4～6年级"></Radio
                ></Col>
                <Col :xs="20" :sm="16" :md="8" :lg="8">
                  <Radio class="fontbig" label="小学六个年级均适合"></Radio
                ></Col>
              </Row>
            </RadioGroup>
          </div>
          <div class="formbox">
            <div class="formtitle">
              <span>您的授课主题*</span>
            </div>

            <div class="">
              <div class="btline" v-for="(v, key) in postData.kc" :key="key">
                <div>
                  <RadioGroup class="" v-model="v.kcradio" size="large">
                    <Row>
                      <Col
                        :xs="24"
                        :sm="24"
                        :md="12"
                        :lg="12"
                        v-for="(v, k) of volunteerData.curriculum"
                        :key="k"
                      >
                        <Radio
                          class=""
                          :value="v.subtitle"
                          :label="key > 0 ? v.subtitle : v.title"
                        ></Radio
                      ></Col>
                    </Row>
                  </RadioGroup>
                </div>
                <Row class="fontbig">
                  <Col :xs="24" :sm="24" :md="24" :lg="24">
                    <Input v-model="v.curriculum" placeholder="课程名称" />
                    <Input
                      class="fontbig"
                      v-model="v.course"
                      placeholder="课程简介"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 6 }"
                    />
                  </Col>
                </Row>
                <Button
                  class="mt10"
                  v-if="key"
                  type="error"
                  @click="postData.kc.splice(k, 1)"
                  >删除</Button
                >
              </div>
              <div class="mt10">
                <Button type="primary" @click="pushKs('')">
                  <Icon type="ios-add-circle-outline"></Icon>
                  添加一门课程
                </Button>
              </div>
              <div class="dec mt10">{{ volunteerData.uploadtip }}</div>
              <div>
                <Upload
                  ref="upload"
                  action="https://api.sunlove-iread.com/index.php?s=/Index/index/upload"
                  :format="['zip']"
                  :max-size="10 * 1024"
                  :on-success="handleSuccess"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove"
                >
                  <Button icon="ios-cloud-upload-outline">上传教案</Button>
                </Upload>
              </div>
            </div>
          </div>

          <div class="formbox">
            <div class="formtitle">您的优势</div>
            <div>
              <Row class="fontbig">
                <Col :xs="24" :sm="24" :md="24" :lg="24">
                  <Input
                    class="fontbig"
                    v-model="postData.teaching"
                    placeholder="是否有支教经验？"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                  />

                  <Input
                    class="fontbig"
                    v-model="postData.speciality"
                    placeholder="是否有个人特长？"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                  />

                  <Input
                    class="fontbig"
                    v-model="postData.reason"
                    placeholder="您参与支教活动的理由是？"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                  />
                </Col>
              </Row>
            </div>
          </div>

          <div class="formbox submitbox">
            <button v-if="!volunteerData.isStart">志愿者报名已截止</button>
            <button v-if="volunteerData.isStart" @click="submit()">提交</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import header from "../public/header.vue";
// import footer from "../public/footer.vue";
// import routerLink from "../public/routerlink.vue";
export default {
  name: "app",
  components: {
    // 'app-header': header,
    // 'app-footer': footer,
    // 'routerLink': routerLink,
    // routerLink,
  },
  data() {
    return {
      modal2: false,
      volunteerData: {},
      resiteData: {},
      postData: {
        agegroup: "",
        city: "",
        kc: [{ curriculum: "", course: "" }],
        kcradio: "",
        kcfile: [],
        course: "",
        curriculum: "",
        edu: "",
        email: "",
        mobile: "",
        name: "",
        province: "",
        reason: "",
        school: "",
        sex: "",
        single: [],
        speciality: "",
        teaching: "",
        unit: "",
        year: "",
        car: ""
      },
      routername: "",
      routerData: [{ title: "我要参与", link: "volunteer" }]
    };
  },
  created() {
    this.resiteData = JSON.parse(JSON.stringify(this.postData));
    this.routername = this.$route.name;
    this.$Message.config({
      top: 120,
      duration: 3
    });
    this.$http.get("/Index/Config/data&key=volunteer").then(res => {
      this.volunteerData = res.value;
    });
    //this.modal2=true
    //  this.$http.get("/Index/Config/data&key=volunteer").then(res => {
    //       this.volunteerData= res.value;
    //     });
  },
  methods: {
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      this.postData.kcfile.splice(this.postData.kcfile.indexOf(file.url), 1);
    },
    handleSuccess(res, file) {
      file.url = res.body.url;
      this.postData.kcfile.push(res.body.url);
    },
    handleFormatError() {
      this.$Modal.warning({
        title: "格式不正确请上传zip格式"
      });
    },
    handleMaxSize() {
      this.$Modal.warning({
        title: "上传文件超过最大限制5MB"
      });
    },
    handleBeforeUpload() {
      const check = this.postData.kcfile.length < 1;
      if (!check) {
        this.$Modal.warning({
          title: "只能上传一个附件"
        });
      }
      return check;
    },
    pushKs() {
      this.postData.kc.push({ curriculum: "", course: "", kcradio: "" });
    },
    submit() {
      if (!(this.postData.single.length > 0)) {
        this.$Message.error("请选择支教地点");
        return;
      }
      if (!this.postData.name) {
        this.$Message.error("请填写姓名");
        return;
      }
      if (!this.postData.year) {
        this.$Message.error("请填写出生年份");
        return;
      }
      if (!this.postData.edu) {
        this.$Message.error("请选择学历");
        return;
      }
      if (!this.postData.sex) {
        this.$Message.error("请选择性别");
        return;
      }
      if (!this.postData.unit) {
        this.$Message.error("请填写所在单位/学校与岗位");
        return;
      }

      if (!this.postData.school) {
        this.$Message.error("请填写毕业学校");
        return;
      }
      if (!this.postData.mobile) {
        this.$Message.error("请填写手机号码");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.postData.mobile)) {
        this.$Message.error("手机号码有误，请重填");
        return false;
      }
      if (!this.postData.email) {
        this.$Message.error("请填写邮箱地址");
        return;
      }
      let reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (!reg.test(this.postData.email)) {
        this.$Message.error("请填写正确的邮箱!");
        return;
      }
      if (!this.postData.province) {
        this.$Message.error("请填写省");
        return;
      }
      if (!this.postData.city) {
        this.$Message.error("请填写市");
        return;
      }
      if (!this.postData.city) {
        this.$Message.error("请填写市");
        return;
      }
      if (!this.postData.car) {
        this.$Message.error("请选择是否为车主");
        return;
      }
      // if (!this.postData.course) {
      //   this.$Message.error("课程内容与教学设计");
      //   return;
      // }

      // if (!this.postData.kc) {

      //   this.$Message.error("课程名称或主题");
      //   return;
      // }
      if (!this.postData.agegroup) {
        this.$Message.error("请选择适应年级");
        return;
      }

      this.$http.post("/Index/Index/volunteer", this.postData).then(res => {
        if (res) {
          this.postData = JSON.parse(JSON.stringify(this.resiteData));
          this.modal2 = true;
          this.$refs.upload.fileList = [];
        }

        // this.$Message.success("提交成功");
        // this.$Modal.success({
        //             title: 'Title',
        //             content: '<p>Content of dialog</p><p>Content of dialog</p>',
        //             okText: 'OK',
        //             cancelText: 'Cancel'
        //         });
      });
      // console.log(this.postData);
    }
  },
  mounted() {}
};
</script>
<style lang="less" >
.ivu-modal-confirm-head,
.ivu-modal-confirm-footer {
  text-align: center !important;
}
.ivu-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
@media (max-width: 576px) {
  .ivu-modal {
    width: 80% !important;
    margin: 10px;
  }
}
</style>
<style lang="less" scoped>
.b1,
.b2,
.b3,
.b4,
.m1,
.m2 {
  display: none;
}
.banner {
  position: relative;
}
.banner img {
  width: 100%;
}

.container-full {
  background: #f7f7f7;
}
.fontbig {
  //   font-size: 24px;
  margin-top: 20px;
}
.msg {
  padding: 36px;
  border-top: 9px solid #eb565a;
  background-color: #fff;
  //   width: 850px;
  //   height: 603px;
  width: 100%;
  margin-right: 50px;
  float: left;
  h3 {
    font-size: 28px;
    font-weight: 500;
  }
  p {
    white-space: pre-line;
    font-size: 22px;
    line-height: 30px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    margin-top: 40px;
    text-align: justify;
  }
}
.p1 {
  padding: 70px 0 90px;
  clear: both;
  overflow: hidden;
}
.map {
  height: 600px;
  width: 680px;
  float: left;
}
.p2 {
  padding: 80px 250px;
  background-color: #fff;
}
.submitbox {
  text-align: center;
  button {
    // width: 150px;
    padding: 0 20px;
    height: 58px;
    line-height: 58px;
    border: 1px solid #eb565a;
    color: #eb565a;
    background: #fff;
  }
}
.p2top {
  ul.a {
    display: flex;
    justify-content: space-around;
    padding: 0;
    li {
      white-space: pre-line;
      list-style: none;
      width: 100%;
      font-size: 20px;
      line-height: 53px;
      color: #222;
    }
    li.one {
      flex: 1 0 150px;
      width: 150px;
      font-size: 24px;
      font-weight: 500;
      text-align: right;
    }
    li.two {
      flex: 1 0 150px;
      width: 150px;
      font-size: 18px;
      text-align: right;
    }
  }
}
.formtitle {
  font-size: 28px;
  font-weight: 500;
  line-height: 53px;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
}

.stitle {
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
}
.form-margin-top {
  margin-top: 20px;
}
.formbox {
  padding: 30px 0;
  border-top: 1px dashed #dcdcdc;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
  .row {
    .col-md-6 {
      margin-top: 22px;
    }
    /*  */

    /*  */
  }
}
/deep/ .ivu-checkbox-wrapper {
  font-size: 16px;
}
.pbox {
  overflow: hidden;
  float: left;
}
@media (min-width: 1201px) {
  .b1 {
    display: block;
  }
}

@media (min-width: 1640px) {
  .m1 {
    display: block;
  }
}
@media (max-width: 1640px) and (min-width: 1200px) {
  .m2 {
    display: block;
  }
  .map {
    height: 676px;
    width: 482px;
  }
  .msg {
    //   width: 850px;
    //   height: 603px;
    width: 100%;
    box-sizing: border-box;
  }
  .p2 {
    padding: 60px 100px;
    background-color: #fff;
  }
}

@media (max-width: 1200px) and (min-width: 768px) {
  .b2 {
    display: block;
  }
  .msg {
    float: none;
    width: 100%;
    height: auto;
  }

  .m1 {
    display: block;
  }
  .pbox {
    padding: 0 30px;
  }
  .map {
    margin-top: 50px;
    width: 100%;
    img {
      width: 100%;
      height: 500px;
    }
  }
  .video-list {
    width: 100% !important;
    padding: 0;
  }
  .p2 {
    padding: 60px 20px;
    background-color: #fff;
  }
}

@media (max-width: 900px) {
  .p2top {
    ul {
      display: flex;
      li {
        list-style: none;
        font-size: 16px;
        line-height: 53px;
        color: #222;
      }
      li.one {
        flex: 1 0 150px;
        width: 150px;
        font-size: 20px;
        font-weight: 500;
        text-align: right;
      }
    }
  }
}
@media (max-width: 768px) {
  .p1 {
    padding: 30px 0 40px;
    clear: both;
    overflow: hidden;
  }
  .b3,
  .m1,
  .b4 {
    display: block;
  }
  .msg {
    float: none;
    width: 100%;
    height: auto;
    padding: 16px;
    h3 {
      font-size: 18px;
      font-weight: 500;
    }
    p {
      font-size: 12px;
      line-height: 18px;
      margin-top: 20px;
    }
  }
  .formtitle {
    font-size: 18px;
    line-height: 24px;
  }
  .pbox {
    padding: 0 30px;
  }
  .map {
    margin-top: 50px;
    height: 300px;
    width: 100%;
    img {
      width: 100%;
      height: 500px;
    }
  }
  .video-list {
    width: 100% !important;
    padding: 0;
  }
  .p2 {
    padding: 60px 20px;
    background-color: #fff;
  }
  .p2top {
    ul {
      display: flex;
      justify-content: space-around;
      flex-flow: wrap;
      clear: both;
      li {
        list-style: none;
        width: 100%;
        font-size: 12px !important;
        line-height: 24px !important;
        color: #222;
      }
      li.one {
        flex: 1 0 80px !important;
        font-size: 18px !important;
        margin: 10px 0;
        font-weight: bold;
        text-align: left !important;
      }
      li.two {
        flex: 1 0 100px;
        font-size: 14px;
        text-align: left !important;
        text-align: justify;
      }
    }
  }
  .submitbox {
    text-align: center;
    button {
      // width: 80px;
      padding: 0px 15px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      border: 1px solid #eb565a;
      color: #eb565a;
      background: #fff;
    }
  }
}
.dec {
  font-size: 12px;
}
.btline {
  border-bottom: 1px dashed #dcdcdc;
  padding: 10px 0;
}
/deep/ .ivu-upload-list {
  font-size: 12px;
}
.mt10 {
  margin-top: 10px;
}
.b4 {
  position: absolute;
  width: 40px !important;
  left: 50%;
  bottom: 100px;
  margin-left: -20px;
  animation: bounce-inSS 2s infinite;
}
@keyframes bounce-inSS {
  0% {
    transform: translateY(0);
    // opacity: 0.8;
  }
  80% {
    transform: translateY(-20px);
    opacity: 1;
  }
  100% {
    transform: translateY(-20px);
    // opacity: 1;
  }
}
</style>